@if (displayValue) {
  @switch (pipeType) {
    @case ('date') {
      {{ displayValue | date:pipeArgs }}
    }
    @case ('currency') {
      {{ displayValue | currency:pipeArgs }}
    }
    @default {
      {{ displayValue }}
    }
  }
} @else {
  N/A
}
